import React, { useEffect, useState } from 'react';
import { FilterList, KeyboardArrowDown, KeyboardArrowUp, Close, Add, DeleteForever } from '@mui/icons-material';
import { 
  Badge, 
  Button, 
  Popover, 
  Typography, 
  Box, 
  Grid, 
  FormControl, 
  InputLabel, 
  Select, 
  MenuItem, 
  TextField,
  IconButton
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { FormProvider, useForm, Controller, useFieldArray } from 'react-hook-form';
import dayjs from 'dayjs';
import { CalendarIcon, DesktopDatePicker } from '@mui/x-date-pickers';

const SingleColumnFilter = ({ 
  filterableColumns, 
  onApplyFilter, 
  externalClear = false, // to handle external clear
  defaultFilterCount = 1 ,
  defaultFilterOptions // this is used in service expert list as pagination model is saved in local storage ...if filter options is present then only
}) => {
  const filterFormMethod = useForm({
    mode: "onChange",
    defaultValues: {
      filterOption: defaultFilterOptions?.length>0? defaultFilterOptions : Array(defaultFilterCount).fill().map(() => ({ 
        fieldName: '', 
        operator: 'contains', 
        value: null 
      }))
    }
  });

  const { control, handleSubmit, reset, setValue, getValues, watch } = filterFormMethod;
  const [anchorEl, setAnchorEl] = useState(null);

  const { fields, append, remove } = useFieldArray({
    control,
    name: "filterOption"
  });

  // React to external clear prop that means clear the filter from other component
  useEffect(() => {
    if (externalClear) {
      reset({
        filterOption: [{ 
          fieldName: '', 
          operator: 'contains', 
          value: null 
        }]
      });
    }
  }, [externalClear, reset]);

  const filterOption = watch('filterOption');

  const activeBadgeContent = filterOption.filter(
    row => row.fieldName && row.value
  ).length;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    if(activeBadgeContent > 0){
      onApplyFilter(getValues());
    }
  };

  const openFilterForm = Boolean(anchorEl);

//   const getAvailableColumns = (currentIndex) => {
//     const selectedColumns = filterOption
//       .filter((_, index) => index !== currentIndex)
//       .map(option => option.fieldName)
//       .filter(Boolean);

//     return filterableColumns.filter(column => 
//       !selectedColumns.includes(column.key)
//     );
//   };

  const handleColumnChange = (e, index, columnField) => {
    const selectedColumn = filterableColumns.find(col => col.key === e.target.value);
    
    // Reset the value
    setValue(`filterOption.${index}.value`, null);
    
    // Set default operator based on column type
    if (selectedColumn?.type === 'date') {
      setValue(`filterOption.${index}.operator`, 'equals');
    }else if(selectedColumn?.type === 'email'){
      setValue(`filterOption.${index}.operator`, 'equals');
    }
    else if(selectedColumn?.type === 'select'){
      setValue(`filterOption.${index}.operator`, 'equals');
    } 
    else {
      setValue(`filterOption.${index}.operator`, 'contains');
    }
    
    // Call the original onChange handler
    columnField.onChange(e);
  };

  
  const renderValueField = (field, index) => {
    const selectedColumn = filterableColumns.find(
      col => col.key === filterOption[index]?.fieldName
    );

    const currentOperator = filterOption[index]?.operator;
  
    // Handle different input types
    switch(selectedColumn?.type) {
      case 'date':
        // If operator is 'between', render two date pickers
        if (currentOperator === 'between') {
          return (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Box sx={{ display: 'flex', gap: 1, width: '100%' }}>
                <DesktopDatePicker
                  // disabled={!watch('services').length>0 || !watch('customer')}
                  
                  label="Start Date"
                  value={field.value? dayjs(field.value) : null}
                  onChange={(newValue) => {
                    field.onChange(newValue ? dayjs(newValue).endOf('day').toISOString() : null);
                  }}
                  format="DD-MM-YYYY" // Display format for user
                  // minDate={dayjs()}
                  slots={{
                    openPickerIcon: (props) => (
                      <CalendarIcon 
                        {...props} 
                        sx={{ 
                          fontSize: '1rem', // Control icon size
                          color: 'gray',    // Optional: control icon color
                          padding:0
                        }} 
                      />
                    ),
                  }}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      required: true,
                      size: 'small',
                      variant: 'standard', // Use standard variant to match existing design
                      InputProps: {
                        // disableUnderline: true, // Remove underline if using standard variant
                        // inputProps: {
                          style: {
                            height: '1.6rem',  
                            fontSize: '0.75rem',                        
                          },
                        // },
                      },
                      InputLabelProps: {
                        style: {
                          fontSize: '0.75em'
                        }
                      }
                    }
                  }}
                />
                {/* <DatePicker
                  label="Start Date"
                  value={field.value}
                  onChange={(newValue) => {
                    field.onChange(newValue ? newValue.format("DD-MM-YYYY") : null);
                  }}
                  format="DD-MM-YYYY"
                  renderInput={(params) => (
                    <TextField 
                      {...params} 
                      variant='standard' 
                      size='small'
                      InputProps={{
                        inputProps: {
                          style: {
                            height: '1.2rem',  
                            fontSize: '0.75rem',                        
                          },
                        },
                      }}  
                      InputLabelProps={{
                          style: {
                              fontSize: '0.75em'
                          }
                      }}  
                    />
                  )}
                /> */}
                <DesktopDatePicker
                  label="End Date"
                  value={filterOption[index]?.endValue ? dayjs(filterOption[index]?.endValue) : null}
                  onChange={(newValue) => {
                    setValue(`filterOption.${index}.endValue`, newValue ? dayjs(newValue).endOf('day').toISOString() : null);
                  }}
                  format="DD-MM-YYYY"
                  slots={{
                    openPickerIcon: (props) => (
                      <CalendarIcon 
                        {...props} 
                        sx={{ 
                          fontSize: '1rem', // Control icon size
                          color: 'gray',    // Optional: control icon color
                          padding:0
                        }} 
                      />
                    ),
                  }}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      required: true,
                      size: 'small',
                      variant: 'standard', // Use standard variant to match existing design
                      InputProps: {
                        // disableUnderline: true, // Remove underline if using standard variant
                        // inputProps: {
                          style: {
                            height: '1.6rem',  
                            fontSize: '0.75rem',                        
                          },
                        // },
                      },
                      InputLabelProps: {
                        style: {
                          fontSize: '0.75em'
                        }
                      }
                    },            
                  }}
                  componentsProps={{
                    actionBar: {
                      actions: [], // Remove action buttons in calendar
                    },
                  }}
                />
              </Box>
            </LocalizationProvider>
          );
        }
        
        // Default single date picker for other date operators
        return (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DesktopDatePicker
              label={selectedColumn.label}
              value={field.value ? dayjs(field.value) : null}
              onChange={(newValue) => {
                field.onChange(newValue? dayjs(newValue).endOf('day').toISOString(): null);
              }}
              format="DD-MM-YYYY"
              slots={{
                openPickerIcon: (props) => (
                  <CalendarIcon 
                    {...props} 
                    sx={{ 
                      fontSize: '1rem', // Control icon size
                      color: 'gray',    // Optional: control icon color
                      padding:0
                    }} 
                  />
                ),
              }}
              slotProps={{
                textField: {
                  fullWidth: true,
                  required: true,
                  size: 'small',
                  variant: 'standard', // Use standard variant to match existing design
                  InputProps: {
                    // disableUnderline: true, // Remove underline if using standard variant
                    // inputProps: {
                      style: {
                        height: '1.6rem',  
                        fontSize: '0.75rem',                        
                      },
                    // },
                  },
                  InputLabelProps: {
                    style: {
                      fontSize: '0.75em'
                    }
                  }
                }
              }}
            />
          </LocalizationProvider>
        );
      
      case 'select':
        return (
          <FormControl variant='standard' sx={{ width:'100%' }} size="small">
            <InputLabel id={`select-label-${index}`} sx={{fontSize:'.75em', lineHeight:'2em'}}>
              {selectedColumn.label}
            </InputLabel>
            <Select
              {...field}
              labelId={`select-label-${index}`}
              value={field.value || ''}
              onChange={(e) => {
                field.onChange(e);
              }}
              sx={{
                minHeight: '0px',
                height: '1.6rem',
                fontSize: '0.75rem',
                fontWeight: '600',
                textTransform:'capitalize'
              }}
            >
              {selectedColumn.options.map(option => (
                <MenuItem key={option.value} value={option.value} sx={{fontSize:'0.75rem'}}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        );
      
      case 'number':
        return (
          <TextField 
            {...field} 
            type="number"
            size='small'
            variant='standard'
            label='Value'
            InputProps={{
              inputProps: {
                style: {
                  height: '1.2rem',     
                  fontSize: '0.75rem',                     
                },
              },
            }}
            InputLabelProps={{
                style: {
                    fontSize: '0.75em'
                }
            }}    
          />
        );
      
      case 'boolean':
        return (
          <FormControl variant='standard' sx={{ width:'100%' }} size="small">
            <InputLabel id={`boolean-label-${index}`} sx={{fontSize:'.75em', lineHeight:'2em'}}>
              {selectedColumn.label}
            </InputLabel>
            <Select
              {...field}
              labelId={`boolean-label-${index}`}
              value={field.value || ''}
              onChange={(e) => {
                field.onChange(e);
              }}
              sx={{
                minHeight: '0px',
                height: '1.6rem',
                fontSize: '0.75rem',
                fontWeight: '600',
                textTransform:'capitalize'
              }}
            >
              <MenuItem value="true" sx={{fontSize:'.75rem'}}>Yes</MenuItem>
              <MenuItem value="false" sx={{fontSize:'.75rem'}}>No</MenuItem>
            </Select>
          </FormControl>
        );
      
      // Default to text input
      default:
        return (
          <TextField 
            {...field} 
            size='small'
            variant='standard'
            label='Value'
            InputProps={{
              inputProps: {
                style: {
                  height: '1.2rem',  
                  fontSize: '0.75rem',                        
                },
              },
            }}  
            InputLabelProps={{
                style: {
                    fontSize: '0.75em'
                }
            }}  
          />
        );
    }
  };

  const getOperators = (columnType) => {
    switch(columnType) {
      case 'select':
        return [
          { value: 'equals', label: 'Is' },
        ];
      case 'email':
        return [
          // { value: 'contains', label: 'Contains' },
          { value: 'equals', label: 'Equals' },
        ];
      case 'number':
        return [
          { value: 'contains', label: 'Contains' },
          // { value: 'equals', label: 'Equals' },
          // { value: 'greaterThan', label: 'Greater Than' },
          // { value: 'lessThan', label: 'Less Than' }
        ];
      case 'date':
        return [
          { value: 'equals', label: 'Equals' },
          { value: 'lessThan', label: 'Before' },
          { value: 'greaterThan', label: 'After' },
          { value: 'between', label: 'Between' }
        ];
      case 'text':
      default:
        return [
          { value: 'contains', label: 'Contains' },
          // { value: 'equals', label: 'Equals' },
          // { value: 'startsWith', label: 'Starts With' },
          // { value: 'endsWith', label: 'Ends With' }
        ];
    }
  };


  // Modify onApplyFilter to handle date range
  const handleApplyFilter = (data) => {
    // Transform data to handle date range
    const transformedFilterOptions = data.filterOption.map(option => {
      if (option.fieldName && filterableColumns.find(col => col.key === option.fieldName)?.type === 'date') {
        if (option.operator === 'between') {
          return {
            ...option,
            value: option.value ? dayjs(option.value).toISOString() : null,
            endValue: option.endValue ? dayjs(option.endValue).toISOString() : null
          };
        }

        console.log("transformedFilterOptions:",{
          ...option,
          value: option.value ? dayjs(option.value).toISOString() : null
        });
        return {
          ...option,
          value: option.value ? dayjs(option.value).toISOString() : null
        };
      }
      return option;
    });

    onApplyFilter({ ...data, filterOption: transformedFilterOptions });
  };

  return (
    <>
      <Button
        onClick={handleClick}
        sx={{
          textTransform: 'none',
        }}
        startIcon={ 
        <Badge 
          sx={{
            '& .MuiBadge-badge': {
              fontSize: '0.5rem',
              fontWeight: '600',
              minWidth: '0',
              height: 'auto',
              padding: '10% 17%',
              borderRadius: '50%'
            },
            width: 'fit-content'
          }}  
          badgeContent={activeBadgeContent} 
          color="primary"
          invisible={activeBadgeContent === 0}
        >
          <FilterList />
        </Badge>
        }
      >
        Filter
      </Button>
      <Popover
        open={openFilterForm}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        PaperProps={{
          sx: { 
            width: {xs:'100%',sm:'40%'},
            p: '0.5rem 1rem',
            // mt: 1
          }
        }}
      >
        <FormProvider {...filterFormMethod}> 
            <Box sx={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                <Typography
                    sx={{
                    fontSize: '1rem',
                    fontWeight: 500,
                    mb: 1
                    }}
                >
                    Filter Options:
                </Typography>
            </Box>
            <Box component={'form'} onSubmit={handleSubmit(handleApplyFilter)}>
                {fields.map((field, index) => (
                <Grid container spacing={1} key={field.id} sx={{}}>
                    
                    <Grid item xs={3}>
                        <Controller
                            name={`filterOption.${index}.fieldName`}
                            control={control}
                            render={({ field: columnField }) => (
                            <FormControl variant='standard' sx={{ width:'100%' }} size="small">
                                <InputLabel id={`column-select-label-${index}`} sx={{fontSize:'.75em', lineHeight:'2em'}}>
                                Column
                                </InputLabel>
                                <Select
                                    {...columnField}
                                    labelId={`column-select-label-${index}`}
                                    value={columnField.value || ''}                                                
                                    onChange={(e) => handleColumnChange(e, index, columnField)}
                                    sx={{
                                        minHeight: '0px',
                                        height: '1.6rem',
                                        fontSize: '0.75rem',
                                        fontWeight: '600',
                                        textTransform:'capitalize'
                                    }}
                                >
                                {filterableColumns.map((column) => (
                                    <MenuItem key={column.key} value={column.key} sx={{textTransform:'capitalize',fontSize:'0.75rem'}}>
                                        {column.label}
                                    </MenuItem>
                                ))}
                                </Select>
                            </FormControl>
                            )}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <Controller
                            name={`filterOption.${index}.operator`}
                            control={control}
                            defaultValue='contains'
                            render={({ field: operatorField }) => {
                            const selectedColumn = filterableColumns.find(
                                col => col.key === filterOption[index]?.fieldName
                            );
                            const operators = getOperators(selectedColumn?.type || 'text');

                            return (
                                <FormControl variant='standard' sx={{ width:'100%' }} size="small">
                                <InputLabel id={`operator-select-label-${index}`} sx={{fontSize:'.75em', lineHeight:'2em'}}>
                                    Operator
                                </InputLabel>
                                <Select
                                    {...operatorField}
                                    labelId={`operator-select-label-${index}`}
                                    value={operatorField.value || 'contains'}
                                    sx={{
                                    minHeight: '0px',
                                    height: '1.6rem',
                                    fontSize: '0.75rem',
                                    fontWeight: '600',
                                    }}
                                >
                                    {operators.map(op => (
                                    <MenuItem key={op.value} value={op.value} sx={{fontSize:'0.75rem'}}>
                                        {op.label}
                                    </MenuItem>
                                    ))}
                                </Select>
                                </FormControl>
                            );
                            }}
                        />
                    </Grid>
                    <Grid item xs={5}>
                        <Controller
                            name={`filterOption.${index}.value`}
                            control={control}
                            render={({ field: valueField }) => renderValueField(valueField, index)}
                        />
                    </Grid>
                    <Grid item xs={.5} sx={{display:"flex", alignItems:'self-end'}}>                        
                        <IconButton 
                            size='small' 
                            sx={{p:0}}
                            onClick={() => {
                                setValue(`filterOption.${index}.fieldName`, '');
                                setValue(`filterOption.${index}.value`, null);
                                handleClose();
                            }}
                        >
                            <Close/>
                        </IconButton>                    
                    </Grid>
                </Grid>
                ))}

                <Box sx={{display:'flex', justifyContent:'flex-end', mt: 1}}>
                    <Button 
                        size='small' 
                        onClick={() => {
                        // reset()
                        handleClose()
                        } }
                        disabled={activeBadgeContent === 0}  
                        // startIcon={<DeleteForever/>}
                    >
                        Apply Filter
                    </Button>
                </Box>
            </Box>
        </FormProvider>
      </Popover>
    </>
  );
};

export default SingleColumnFilter;
